import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import * as Sentry from '@sentry/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

export default function FeedbackStressPage() {
  const { t } = useTranslation()
  const submit = useSubmit()
  const [stressLevel, setStressLevel] = useState<number>(5)

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem('onboarding_stress')
      if (stored) {
        setStressLevel(parseInt(stored))
      }
    } catch (error) {
      Sentry.captureException(error)
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  const isHighStress = stressLevel > 6

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col text-center">
        <div className="flex grow flex-col items-center justify-center px-4">
          <div className="mb-6 text-6xl">{isHighStress ? '🫂' : '💪'}</div>

          <h1 className="custom-heading mb-4 text-2xl leading-tight">
            {isHighStress
              ? t('pages.onboarding.feedbackStress.highStressTitle')
              : t('pages.onboarding.feedbackStress.lowStressTitle')}
          </h1>

          <p className="mb-6 max-w-sm leading-relaxed text-gray-600">
            {isHighStress
              ? t('pages.onboarding.feedbackStress.highStressDescription')
              : t('pages.onboarding.feedbackStress.lowStressDescription')}
          </p>

          <div className="max-w-sm rounded-2xl bg-gradient-to-r from-blue-50 to-purple-50 p-4">
            <p className="text-sm text-gray-700 italic">
              {t('pages.onboarding.feedbackStress.researchNote')}
            </p>
          </div>
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue"
          />
        </Form>
      </div>
    </Layout>
  )
}
